const ROOT_FONT_SIZE = 16;

/**
 *
 * pxToRem
 *
 * Convert a pixel number to a formatted rem unit
 * @param {number} size - The pixel number.
 * @returns {string} - Formatted rem unit
 */
export const pxToRem = (size: number) => `${size / ROOT_FONT_SIZE}rem`;
